// @flow
import type { Item } from '../item';

let createItemId = 0;
const newItemFactory = (inputValue) => {
  return {
    label: inputValue,
    value: (createItemId -= 1).toString(),
    userCreated: true,
  };
};

function allowItemCreation(items, searchTerm, previouslyCreatedItems) {
  if (searchTerm === '') {
    return false;
  }

  const allItems = items.concat(previouslyCreatedItems);

  return !allItems.some((i) => i.label === searchTerm);
}

const withCreatable = (
  items: Array<Item>,
  searchTerm: string,
  previouslyCreatedItems: Array<Item>
) => {
  if (allowItemCreation(items, searchTerm, previouslyCreatedItems)) {
    return [...items, newItemFactory(searchTerm)];
  } else {
    return items;
  }
};

export { withCreatable };
